import { QueryClient } from '@tanstack/react-query';
import { isApiError } from '@shared/api/api-error';

/**
 * Shared TanStack Query client with production defaults:
 * - Do not retry on 4xx client errors (they are deterministic).
 * - Retry transient/server errors up to twice with capped backoff.
 * - A one-minute stale window balances freshness against request volume.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (isApiError(error) && error.status >= 400 && error.status < 500) {
          return false;
        }
        return failureCount < 2;
      },
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 30_000),
    },
    mutations: {
      retry: false,
    },
  },
});
